module.exports = __webpack_public_path__ + "media/images/emblems/Bussnang-Blazono-abcc33ff591cf84285bac6a993667267.png";